module.exports = __webpack_public_path__ + "static/img/Chevy-Stewart.418aee7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Chevy-Stewart.jpg
// module id = VSIh
// module chunks = 0